import { LoadingPage } from "@/components/LoadingPage";
import { Section } from "../components/Section";
import { FeatureFlagSettings } from "../components/settings/FeatureFlags";
import { LabelSettings } from "../components/settings/LabelSettings";
import { TestEnvSettings } from "../components/settings/TestEnvSettings";
import { TimeoutSettings } from "../components/settings/TimeoutSettings";
import { WorklistSettings } from "../components/settings/WorklistSettings";
import { WorkstationPrinterSettings } from "../components/settings/WorkstationPrinterSettings";
import { useSettings } from "../hooks";

export function SettingsPage() {
  const { fetching } = useSettings();

  return fetching ? (
    <LoadingPage />
  ) : (
    <>
      <Section.Title>Settings</Section.Title>
      <div className="flex flex-col gap-6 max-w-3xl">
        <TestEnvSettings />
        <TimeoutSettings />
        <LabelSettings />
        <WorkstationPrinterSettings />
        <WorklistSettings />
        <FeatureFlagSettings />
      </div>
    </>
  );
}
